import { TMobileSignupForm } from './form';
import { TScreenDef } from '../screens/types';

export type TResumeResult =
  | { status: 'pending' }
  | { status: 'screen'; index: number }
  | { status: 'complete' };

const findFirstUnansweredIndex = (
  form: TMobileSignupForm,
  registry: TScreenDef[],
): number => registry.findIndex((screen) => !screen.isAnswered(form));

// The furthest screen the current answers permit the user to reach. stateKey-agnostic
// so the nav guard behaves identically pre- and post-mint (resume owns the mint-gated
// pending/complete states; this owns the "how far forward is allowed" ceiling).
export const furthestAllowedIndex = (
  form: TMobileSignupForm,
  registry: TScreenDef[],
): number => {
  const index = findFirstUnansweredIndex(form, registry);
  return index === -1 ? registry.length - 1 : index;
};

export const firstUnansweredScreen = (
  form: TMobileSignupForm,
  registry: TScreenDef[],
  signupStatus: {
    stateKey?: string;
    isSeeded: boolean;
    isContextResolved: boolean;
  },
): TResumeResult => {
  // A missing stateKey is ambiguous: either genuinely anonymous, or context is
  // still loading on refresh. Hold on pending until context settles, otherwise
  // we'd render screen 0 and clobber the real hash before the resume target loads.
  if (!signupStatus.stateKey) {
    return signupStatus.isContextResolved
      ? { status: 'screen', index: 0 }
      : { status: 'pending' };
  }

  if (!signupStatus.isSeeded) return { status: 'pending' };

  const index = findFirstUnansweredIndex(form, registry);

  return index === -1 ? { status: 'complete' } : { status: 'screen', index };
};
